import { render, staticRenderFns } from "./CardDeckTutorial.vue?vue&type=template&id=4f98c2b3&scoped=true&"
import script from "./CardDeckTutorial.vue?vue&type=script&lang=js&"
export * from "./CardDeckTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98c2b3",
  null
  
)

export default component.exports